var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "more"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v(_vm._s(_vm.all_text.first_text))]), _c('span', [_vm._v(_vm._s(_vm.all_text.second_text))])]), _c('div', {
    staticClass: "arrow",
    attrs: {
      "alt": ""
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };